import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { UserRoleQuery, UserRoleQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(UserRoleQuery)
@Wrapper(UserRoleQueryHandlerBase)
export class UserRoleQueryHandler {
    public constructor(
        http: Http
    ) { }
}
